/**
 * The Swipe function
 */
(function($) {
    $.fn.c24Swipe = function(eventName, callback) {
        const elem = $(this).get(0);
        let xDown = null;
        let yDown = null;

        const events = {
            swipeLeft: 'swipeLeft',
            swipeRight: 'swipeRight',
            swipeUp: 'swipeUp',
            swipeDown: 'swipeDown',
        };

        if (!elem || !events[eventName]) {
            return;
        }

        elem.addEventListener('touchstart', handleTouchStart, {
            capture: false,
            passive: true,
        });
        elem.addEventListener('touchmove', handleTouchMove, {
            capture: false,
            passive: true,
        });

        function handleTouchStart(evt) {
            if (evt.touches && evt.touches[0]) {
                xDown = evt.touches[0].clientX;
                yDown = evt.touches[0].clientY;
            }
        }

        function handleTouchMove(evt) {
            let ratio = 0;
            let eventToTrigger = null;
            if ( ! xDown || ! yDown ) {
                return;
            }

            const xUp = evt.touches[0].clientX;
            const yUp = evt.touches[0].clientY;

            const xDiff = xDown - xUp;
            const yDiff = yDown - yUp;


            if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
                ratio = Math.abs(xDiff / yDiff);
                if ( xDiff > 0 ) {
                    / left swipe /;
                    eventToTrigger = events.swipeLeft;
                } else {
                    / right swipe /;
                    eventToTrigger = events.swipeRight;
                }
            } else {
                ratio = Math.abs(yDiff / xDiff);
                if ( yDiff > 0 ) {
                    / up swipe /;
                    eventToTrigger = events.swipeUp;
                } else {
                    / down swipe /;
                    eventToTrigger = events.swipeDown;
                }
            }

            if (ratio > 2.5 && //only trigger if bigger Diff is more than 2.5x as big as smaller diff
               eventName &&
               eventToTrigger === eventName) {
                callback.apply(elem, [evt]);
            }
            / reset values /;
            xDown = null;
            yDown = null;
        }
    };
})(window.jQuery);
